// import { useState } from "react";
import { Drawer as DrawerMui, Box, Typography, Stack, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import BetaBanner from 'assets/image/beta_banner.png';
import useBeta from 'hook/useBeta';
import { BETA_PATH, BETA_PATH_TUTORIAL } from 'utility/constants';
import { sendLogAnalytic } from "_services"
import { useUpdateUserProfile } from "apollo/actions";
import { useDialog } from "context/Dialog";
import { useState } from 'react';

const Drawer = styled(DrawerMui)`
  box-sizing: border-box;
`;

const DrawerHeader = styled('div')`
  background: ${(props) => props.theme.palette.primary.main};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  height: 55px;
  width: 100%;
  box-sizing: border-box;
  /* max-width: 460px; */
`;

export default function DrawerBeta(props) {
  const { open, onClose } = props;
  const { t } = useTranslation();
  const { isUsedBeta } = useBeta();
  return (
    <div>
      <Drawer anchor="right" open={open} onClose={onClose}>
        <Box sx={{ width: { xs: '100%', sm: '460px' } }}>
          <DrawerHeader>
            <CloseIcon
              sx={{ fontSize: '1.5rem', color: '#ffffff', cursor: 'pointer' }}
              onClick={onClose}
            />
            <Box sx={{ fontWeight: 600, fontSize: '1.375rem', color: '#ffffff' }}>
              {t('beta.beta_test')}
            </Box>
          </DrawerHeader>
          <Box sx={{ m: { xs: '20px', sm: '40px' } }}>
            {isUsedBeta ? (
              <ContentGotoOriginal onClose={onClose} />
            ) : (
              <ContentGotoBeta onClose={onClose} />
            )}
          </Box>
        </Box>
      </Drawer>
    </div>
  );
}

const BoxVersion = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.palette.warning.main};
  box-sizing: border-box;
  border-radius: 2px;
  color: ${(props) => props.theme.palette.warning.main};
  width: 77px;
  height: 21px;
  margin: auto;
  font-size: 0.875rem;
  font-weight: 600;
`;

const Root = styled(Box)`
  text-align: center;
`;

const BoxContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContentGotoBeta = ({ onClose }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false)
  const { getCannotSomethingDialog } = useDialog();
  const [getUpdateUserProfile] = useUpdateUserProfile();

  const onContinue = async () => {
    sendLogAnalytic({ logState: 1 });
    try {
      setLoading(true)
      await getUpdateUserProfile({
        variables: {
          userData: {
            useBeta: true,
          },
        },
      });
      setLoading(false)
      window.location.href = BETA_PATH + BETA_PATH_TUTORIAL;
    } catch {
      setLoading(false)
      getCannotSomethingDialog()
    }
  };
  return (
    <>
      <Root>
        <Stack spacing={'25px'}>
          <BoxVersion>Beta Test</BoxVersion>
          <img src={BetaBanner} alt="beta easy" width="100%" />
          <Typography variant="h5">{t('beta.content_goto_beta.title')}</Typography>
          <BoxContent sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
            <Typography variant="body2">{t('beta.content_goto_beta.subtitle1')}</Typography>
            <Typography variant="body2">{t('beta.content_goto_beta.subtitle2')}</Typography>
            <br />
            <Typography variant="body2">{t('beta.content_goto_beta.subtitle3')}</Typography>
          </BoxContent>
        </Stack>
      </Root>
      <Root sx={{ mt: '100px' }}>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <Button
              variant="outlined"
              sx={{
                color: 'text.secondary',
                borderColor: 'text.secondary',
                minWidth: '150px',
              }}
              onClick={onClose}
            >
              {t('beta.content_goto_beta.back')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ minWidth: '150px' }}
              onClick={() => onContinue()}
              disabled={loading}
            >
              {t('beta.content_goto_beta.continue')}
            </Button>
          </Stack>
          <Box sx={{ color: 'text.secondary', fontSize: '0.75px' }}>
            {t('beta.content_goto_beta.subtitle4')}
          </Box>
        </Stack>
      </Root>
    </>
  );
};

export const ContentGotoOriginal = ({ onClose }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false)
  const { getCannotSomethingDialog } = useDialog();
  const [getUpdateUserProfile] = useUpdateUserProfile();

  const onContinue = async () => {
    sendLogAnalytic({ logState: 2 });
    try {
      setLoading(true)
      await getUpdateUserProfile({
        variables: {
          userData: {
            useBeta: false,
          },
        },
      });
      setLoading(false)
      window.location.href = "/";
    } catch {
      setLoading(false)
      getCannotSomethingDialog()
    }
  };
  return (
    <>
      {' '}
      <Root>
        <Stack spacing={'25px'}>
          {/* <BoxVersion>new feature</BoxVersion> */}
          <img src={BetaBanner} alt="beta easy" width="100%" />
          <Typography variant="h5">{t('beta.content_goto_original.title')}</Typography>
          <BoxContent sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
            <Typography variant="body2">{t('beta.content_goto_original.subtitle1')}</Typography>
            <br />
            <Typography variant="body2">{t('beta.content_goto_original.subtitle2')}</Typography>
          </BoxContent>
        </Stack>
      </Root>
      <Root sx={{ mt: '100px' }}>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <Button
              variant="outlined"
              sx={{
                color: 'text.secondary',
                borderColor: 'text.secondary',
                minWidth: '150px',
              }}
              onClick={onClose}
            >
              {t('beta.content_goto_original.back')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ minWidth: '150px' }}
              onClick={() => onContinue()}
              disabled={loading}
            >
              {t('beta.content_goto_original.continue')}
            </Button>
          </Stack>
          <Box sx={{ color: 'text.secondary', fontSize: '0.75px' }}>
            {t('beta.content_goto_original.subtitle3')}
          </Box>
        </Stack>
      </Root>
    </>
  );
};
